import { FormikValues, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

interface Props {
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value?: any;
}

const CampoOculto = ({ name, value }: Props): React.ReactElement =>
{
    const {
        handleBlur,
        handleChange,
        values,
        setFieldValue
    } = useFormikContext<FormikValues>();

    useEffect(() => {
        if (!values[name]) {
            setFieldValue(name, value, true);
        }
    }, [name, setFieldValue, value, values]);

    return (
        <input
            type="hidden"
            name={ name }
            onChange={ handleChange }
            onBlur={ handleBlur }
            value={ value }
        />
    );
}

export default CampoOculto;
